module.exports = Em.View.extend({
    classNames: ['four-oh-four-view']
})
